import React from 'react';

function About() {
  return (
    <div className="about">
      <h1>About Us</h1>
       <p className='info'>Puzzle Club is a welcoming space for students interested in promoting and solving puzzles—no experience required! We explore a wide variety of puzzles, including (but not limited to) jigsaw puzzles, cryptograms, word puzzles, logic puzzles, mechanical puzzles, and riddles. As a club, we'll work together to take on various puzzle hunts, including the MIT Mystery Hunt and Puzzle Hunt CMU, while also hosting our very own. Whether you're looking to challenge yourself, collaborate with others, or just have fun, Puzzle Club is a great place to connect with fellow puzzle enthusiasts.</p>
</div>)}
export default About;